import { type ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../common/LoadingSpinner'
import { isKlantProfielCompleet } from '../../lib/klantProfielHelpers'

const VRIJSTELLENDE_PADEN = new Set(['/klant/login', '/klant/mijn-profiel'])

/**
 * Pure klanten met onvolledig profiel mogen alleen login en profielpagina;
 * andere klant-hub routes → profiel aanvullen.
 */
export function RequireKlantProfielCompleet ({ children }: { children?: ReactNode }) {
  const { user, profile, loading, profileLoading, isKlant } = useAuth()
  const { pathname } = useLocation()

  if (loading || profileLoading) return <LoadingSpinner />

  if (!user || !isKlant) {
    return children ? <>{children}</> : <Outlet />
  }

  if (VRIJSTELLENDE_PADEN.has(pathname)) {
    return children ? <>{children}</> : <Outlet />
  }

  if (!isKlantProfielCompleet(user, profile)) {
    return <Navigate to="/klant/mijn-profiel?aanvullen=1" replace />
  }

  return children ? <>{children}</> : <Outlet />
}
